import { useSelector } from 'react-redux';
import languages from '../languages';

const useLanguage = () => {
  const currentLanguage = useSelector((state) => state.language.language);
  return languages[currentLanguage] || languages.english; // Fallback to English
};

export default useLanguage;